import Vue from 'vue'
import Router from 'vue-router'

// The meta data for your routes
const meta = require('./meta.json')

// Function to create routes
// Is default lazy but can be changed
function route (name, path, view) {
  return {
    name: name,
    path: path,
    meta: meta[name],
    component: resolve => import(`pages/${view}.vue`).then(resolve)
  }
}

Vue.use(Router)

export function createRouter (store) {
  store.dispatch('api/prepareAuthorization')

  let mainAuthRoute = { name: 'dashboard' }

  const router = new Router({
    base: __dirname,
    mode: 'history',
    scrollBehavior: () => ({ y: 0 }),
    routes: [
      // route('booking-new', '/admin/booking/create', 'booking-new'),
      route('booking-edit', '/admin/booking/:booking_id/edit', 'booking'),
      route('create-booking', '/bookings/new', 'create-booking'),
      route('dashboard', '/admin/dashboard', 'dashboard'),
      route('account', '/:username', 'account'),
      route('new-account', '/account/new/:type', 'account'),
      // route('equipment', '/admin/equipment', 'equipment'),
      route('equipment-id', '/admin/equipment/:equipment_id', 'equipment'),
      route('equipments', '/admin/equipments', 'equipments'),
      route('booking-new', '/admin/booking/:booking_id/:booking_start/:booking_end/', 'booking'),
      route('bookingnew', '/admin/booking/:booking_id/', 'booking'),
      route('booking-id', '/admin/booking/:booking_id/', 'booking'),
      // route('booking-added', '/admin/booking/:booking_id/:booking_added/', 'booking'),
      route('bookings', '/admin/bookings', 'bookings'),
      route('admins', '/account/admins', 'admins'),
      route('managers', '/account/managers', 'managers'),
      route('responsibles', '/account/responsibles', 'responsibles'),
      route('installers', '/account/installers', 'installers'),
      route('commerces', '/account/commerces', 'commerces'),
      route('inclusions', '/admin/installation/:type', 'taxonomies'),
      route('exclusions', '/admin/installation/:type', 'taxonomies'),
      route('observations', '/admin/installation/:type', 'taxonomies'),
      route('materials', '/admin/installation/:type', 'taxonomies'),
      route('types', '/admin/installation-types/', 'installation-types'),
      route('installation-type-id', '/admin/installation-type/:installation_type_id/', 'installation-type'),
      route('stats', '/admin/stats', 'stats'),
      route('login', '/account/login', 'session-mannager'),
      route('register', '/account/register', 'session-mannager'),
      route('change-password', '/account/change-password', 'session-mannager'),
      route('recover-password', '/account/recover-password', 'session-mannager'),
      route('privacy-policy', '/legal/privacy-policy', 'legal'),
      route('cookies-policy', '/legal/cookies-policy', 'legal'),
      route('legal-advice', '/legal/legal-advice', 'legal'),
      // Global redirect for 404
      { path: '*', redirect: mainAuthRoute }
    ]
  })

  // Send a pageview to Google Analytics
  router.beforeEach((to, from, next) => {
    if (typeof ga !== 'undefined') {
      /* eslint-disable */
      ga('set', 'page', to.path)
      ga('send', 'pageview')
    }
    let hasCredentials = store.getters['api/hasCredentials']

    let requiresAuth = meta[to.name].requiresAuth || false

    let isSessionPage = meta[to.name].isSessionPage || false

    /**
     * FIX (get oly the status)
     */
    function getUserStatus () {
      return new Promise((resolve, reject) => {
        store.dispatch('api/authRequest', {
          method: 'get',
          url: `user/profile/me/`
        }).then((response) => {
          let index = response.data.findIndex(item => item.assign_to === 'status')
          resolve(parseInt(response.data[index].value))
        }).catch((error) => {
          console.log(error)
          reject(error)
        })
      })
    }

    if (localStorage.rolID > 3) {
      getUserStatus().then((statusID) => {
        if (statusID !== 1) {
          return next(
            {
              name: 'account', 
              params: {
                username: 'me'
              }
            }
          )
        }
      }).catch((error) => {
        console.log(error)
      })
    }

    if (!hasCredentials) {
      if (!requiresAuth) {
        return next()
      }
      return next({ name: 'login'})
    } else {
      if (isSessionPage) {
        return next(mainAuthRoute)
      }
      let userRol = store.getters['api/getUserRol']

      if (meta[to.name].permissions && meta[to.name].permissions.indexOf(userRol) === -1) {
        return next(mainAuthRoute)
      }
    }
    next()
  })

  return router
}



// WEBPACK FOOTER //
// ./src/router/index.js